import { render, staticRenderFns } from "./passagers.vue?vue&type=template&id=37ac9d04&"
import script from "./passagers.vue?vue&type=script&lang=js&"
export * from "./passagers.vue?vue&type=script&lang=js&"
import style0 from "./passagers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports